import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import {MenuButtonAlignCenter} from 'mui-tiptap';

const StyledEditorMenuButtonAlignCenter = styled(MenuButtonAlignCenter)`
  ${ComponentStyles}
`;

StyledEditorMenuButtonAlignCenter.propTypes = {
  theme: PropTypes.object
};

export default StyledEditorMenuButtonAlignCenter;
